import { render } from "../../templates/partner-cart-technology-park-add.html?vue&type=template&id=3b5a5892"
import script from "./technology-park-add.vue?vue&type=script&lang=js"
export * from "./technology-park-add.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__